export default __webpack_public_path__ + "static/media/watch-mobile2.8c826ace.png";